import React from "react";

interface PersonalDetailsProps {
  label: string;
  Icon: React.FC<React.SVGProps<SVGSVGElement>>;
  info: string | number;
}

const PersonalDetails: React.FC<PersonalDetailsProps> = ({
  label,
  Icon,
  info
}) => {
  return (
    <div className="flex flex-col mr-8">
      <p className="mb-1">{label}</p>
      <div className="flex">
        <Icon className="self-center mr-1" />
        <p className="text-[#1672EC]">{info}</p>
      </div>
    </div>
  );
};

export default PersonalDetails;
